import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAllUsersData,
  getUserQueuesData,
  updateUserData,
  createNewUser,
  validateUserQueue,
  getQueueCount,
  changeRunQueryObject,
  updateUserQueues,
  updateUserPassword,
  clearQueueCount
} from '../../redux/action/admin/AdminActions';
import _ from 'lodash';
import { Table, Tooltip, Button, Row, Col, Icon, message, Modal, Input, Checkbox } from 'antd';
import {
  USER_PERMISSIONS,
  USER_TABLE_COLUMNS,
  IMAGE_FILTER_KEY_NAME,
  DOMAIN_FILTER_KEY_NAME,
  REVIEW_FILTER_KEY_NAME,
  QUALITY_FILTER_KEY_NAME,
  SOCIAL_MEDIA_FILTER_KEY_NAME
} from './AdminPageConstants';
import EditUserForm from './components/EditUserForm';
import RegistrationForm from './components/RegistrationForm';
import UserFiltersForm from './components/UserFiltersForm';

import './AdminPage.css';
import ChangePasswordForm from './components/ChangePasswordForm';

class AdminPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showResetPasswordModal: false,
      showUserFilterModal: false,
      showRegistrationModal: false,
      showEditUserModal: false,
      selectedUser: null,
      userFilters: null,
      isVisibleConfirm: false,
      deleteUserData: null,
      showChangePasswordModal: false,
      isSpin: false,
      messageObject: {},
      showMessage: false,
      updatedUserDataIsFetching: false,
      savedUserDataIsFetching: false,
      runUserQuery: false,
      searchTerm: '',
      showDisabledUsers: false
    };

    this.props.getAllUsersData();
    // props.changeNavigationItem(props.menuKey.key)
    // props.setBreadCrumbsOptions(props.menuKey.breadcrumb)
  }

  handleRouteTo = (path) => {
    window.location.pathname = path;
  };

  handleSearchChange = (e) => {
    this.setState({
      searchTerm: e.target.value
    });
  };

  handleShowDisabledUsersChange = (e) => {
    this.setState({
      showDisabledUsers: e.target.checked
    });
  };

  renderUserFiltersModal = () => {
    return (
      <UserFiltersForm
        userData={this.state.selectedUser}
        filterData={this.state.userFilters}
        runQueriesData={this.props.runQueryData}
        isVisible={this.state.showUserFilterModal}
        onCancel={this.handleCloseUserFiltersModal}
        onCreate={this.handleUserFiltersSubmit}
        checkAndGetQueryResult={this.checkAndGetQueryResult}
      />
    );
  };

  checkAndGetQueryResult = (
    query,
    filterType,
    runQueryObject,
    queryKey,
    status
  ) => {
    let runQueryDataCopy = _.cloneDeep(this.props.runQueryData);
    let preparedQueryObject = {
      orderIndex: 0,
      query: query,
      type: filterType
    };

    switch (status) {
      case 'check':
        this.setState(
          {
            runUserQuery: false
          },
          () => {
            this.props.validateUserQueue(preparedQueryObject).then(() => {
              if (!_.isEmpty(this.props.userQueueValidDataErrorMessage)) {
                message.error(this.props.userQueueValidDataErrorMessage, 4);
              } else {
                message.success('Query validate successfully', 4);
              }
            });
          }
        );
        break;
      case 'execute':
        this.setState(
          {
            runUserQuery: false
          },
          () => {
            this.props.validateUserQueue(preparedQueryObject).then(() => {
              if (!_.isEmpty(this.props.userQueueValidDataErrorMessage)) {
                message.error(this.props.userQueueValidDataErrorMessage, 4);
              } else {
                if (runQueryDataCopy.hasOwnProperty(filterType)) {
                  let finnIndex = _.findIndex(runQueryDataCopy[filterType], {
                    orderIndex: runQueryObject.orderIndex
                  });

                  if (finnIndex !== -1) {
                    runQueryDataCopy[filterType][finnIndex].queryResult = '';
                    runQueryDataCopy[filterType][finnIndex].runStatus = true;
                  } else {
                    runQueryDataCopy[filterType].push(
                      _.merge({}, runQueryObject, {
                        queryResult: '',
                        queryKey: queryKey,
                        runStatus: true
                      })
                    );
                  }
                } else {
                  runQueryDataCopy = _.merge({}, runQueryDataCopy, {
                    [filterType]: [
                      _.merge({}, runQueryObject, {
                        queryResult: '',
                        queryKey: queryKey,
                        runStatus: true
                      })
                    ]
                  });
                }

                this.props.changeRunQueryObject(runQueryDataCopy);

                this.props.getQueueCount(preparedQueryObject).then(() => {
                  if (this.props.userQueueCountErrorMessage) {
                    message.error(this.props.userQueueCountErrorMessage, 4);
                  } else {
                    message.success('Query execute successfully', 4);
                  }

                  let finnIndexForResult = _.findIndex(
                    runQueryDataCopy[filterType],
                    {
                      orderIndex: runQueryObject.orderIndex
                    }
                  );
                  runQueryDataCopy[filterType][
                    finnIndexForResult
                  ].runStatus = false;
                  runQueryDataCopy[filterType][finnIndexForResult].queryResult =
                    this.props.userQueueCount;
                  Promise.resolve(
                    this.props.changeRunQueryObject(runQueryDataCopy)
                  ).then(() => {
                    this.setState({
                      runUserQuery: false
                    });
                  });
                });
              }
            });
          }
        );
        break;

      default:
        break;
    }
  };

  handleCloseUserFiltersModal = () => {
    this.setState({
      showUserFilterModal: false,
      userFilters: null
    });
    this.props.clearQueueCount();
  };

  handleUserFiltersSubmit = (values, filters) => {
    let imageKey = `${IMAGE_FILTER_KEY_NAME.toLocaleLowerCase()}_keys`;
    let domainKey = `${DOMAIN_FILTER_KEY_NAME.toLocaleLowerCase()}_keys`;
    let reviewKey = `${REVIEW_FILTER_KEY_NAME.toLocaleLowerCase()}_keys`;
    let controlKey = `${QUALITY_FILTER_KEY_NAME.toLocaleLowerCase()}_keys`;
    let socialKey = `${SOCIAL_MEDIA_FILTER_KEY_NAME.toLocaleLowerCase()}_keys`;
    let requestArray = [];

    _.forEach(values[imageKey], (queryObject, index) => {
      let isActive = false;

      if (filters && filters[IMAGE_FILTER_KEY_NAME]) {
        let filter = filters[IMAGE_FILTER_KEY_NAME];
        const hasIndex = filter.indexOf(index) > -1;
        isActive = hasIndex ? true : false;
      }

      requestArray.push({
        id: queryObject.id || undefined,
        orderIndex: index,
        query:
          values[
          `${IMAGE_FILTER_KEY_NAME.toLowerCase()}_sql_${queryObject.orderIndex
          }`
          ],
        description:
          values[
          `${IMAGE_FILTER_KEY_NAME.toLowerCase()}_description_${queryObject.orderIndex
          }`
          ],
        active: isActive,
        type: IMAGE_FILTER_KEY_NAME
      });
    });

    _.forEach(values[domainKey], (queryObject, index) => {
      let isActive = false;

      if (filters && filters[DOMAIN_FILTER_KEY_NAME]) {
        let filter = filters[DOMAIN_FILTER_KEY_NAME];
        const hasIndex = filter.indexOf(index) > -1;
        isActive = hasIndex ? true : false;
      }

      requestArray.push({
        id: queryObject.id || undefined,
        orderIndex: index,
        query:
          values[
          `${DOMAIN_FILTER_KEY_NAME.toLowerCase()}_sql_${queryObject.orderIndex
          }`
          ],
        description:
          values[
          `${DOMAIN_FILTER_KEY_NAME.toLowerCase()}_description_${queryObject.orderIndex
          }`
          ],
        active: isActive,
        type: DOMAIN_FILTER_KEY_NAME
      });
    });

    _.forEach(values[reviewKey], (queryObject, index) => {
      let isActive = false;

      if (filters && filters[REVIEW_FILTER_KEY_NAME]) {
        let filter = filters[REVIEW_FILTER_KEY_NAME];
        const hasIndex = filter.indexOf(index) > -1;
        isActive = hasIndex ? true : false;
      }

      requestArray.push({
        id: queryObject.id || undefined,
        orderIndex: index,
        query:
          values[
          `${REVIEW_FILTER_KEY_NAME.toLowerCase()}_sql_${queryObject.orderIndex
          }`
          ],
        description:
          values[
          `${REVIEW_FILTER_KEY_NAME.toLowerCase()}_description_${queryObject.orderIndex
          }`
          ],
        active: isActive,
        type: REVIEW_FILTER_KEY_NAME
      });
    });

    _.forEach(values[controlKey], (queryObject, index) => {
      let isActive = false;

      if (filters && filters[QUALITY_FILTER_KEY_NAME]) {
        let filter = filters[QUALITY_FILTER_KEY_NAME];
        const hasIndex = filter.indexOf(index) > -1;
        isActive = hasIndex ? true : false;
      }

      requestArray.push({
        id: queryObject.id || undefined,
        orderIndex: index,
        query:
          values[
          `${QUALITY_FILTER_KEY_NAME.toLowerCase()}_sql_${queryObject.orderIndex
          }`
          ],
        description:
          values[
          `${QUALITY_FILTER_KEY_NAME.toLowerCase()}_description_${queryObject.orderIndex
          }`
          ],
        active: isActive,
        type: QUALITY_FILTER_KEY_NAME
      });
    });

    _.forEach(values[socialKey], (queryObject, index) => {
      let isActive = false;

      if (filters && filters[SOCIAL_MEDIA_FILTER_KEY_NAME]) {
        let filter = filters[SOCIAL_MEDIA_FILTER_KEY_NAME];
        const hasIndex = filter.indexOf(index) > -1;
        isActive = hasIndex ? true : false;
      }

      requestArray.push({
        id: queryObject.id || undefined,
        orderIndex: index,
        query:
          values[
          `${SOCIAL_MEDIA_FILTER_KEY_NAME.toLowerCase()}_sql_${queryObject.orderIndex
          }`
          ],
        description:
          values[
          `${SOCIAL_MEDIA_FILTER_KEY_NAME.toLowerCase()}_description_${queryObject.orderIndex
          }`
          ],
        active: isActive,
        type: SOCIAL_MEDIA_FILTER_KEY_NAME
      });
    });

    this.props
      .updateUserQueues(this.state.selectedUser.id, requestArray)
      .then(() => {
        console.log(
          'this.props.replacedUserQueuesDataErrorMessage',
          this.props.replacedUserQueuesDataErrorMessage
        );
        if (!_.isEmpty(this.props.replacedUserQueuesDataErrorMessage)) {
          message.error(this.props.replacedUserQueuesDataErrorMessage, 4);
        } else {
          this.setState(
            {
              showUserFilterModal: false,
              selectedUser: null
            },
            () => {
              message.success('Filter save successfully', 4);
            }
          );
        }
      });
  };

  renderRegistrationModal = () => {
    return (
      <RegistrationForm
        isVisible={this.state.showRegistrationModal}
        onCancel={this.handleCloseRegistrationModal}
        onCreate={this.handleRegisterUser}
        permissions={USER_PERMISSIONS}
        permissionKey='description'
        loaderIsVisible={this.state.savedUserDataIsFetching}
      />
    );
  };

  showRegistrationModal = () => {
    this.setState({
      showRegistrationModal: true
    });
  };

  handleCloseRegistrationModal = () => {
    this.setState({
      showRegistrationModal: false
    });
  };

  handleRegisterUser = (values) => {
    let permissionData = _.find(USER_PERMISSIONS, { id: values.role });
    values.role = permissionData.name;
    delete values.confirm;
    // formInstance.resetFields()

    this.setState(
      {
        savedUserDataIsFetching: true
      },
      () => {
        this.props.createNewUser(values).then(() => {
          if (!_.isEmpty(this.props.savedUserDataErrorMessage)) {
            this.setState(
              {
                savedUserDataIsFetching: false
              },
              () => {
                message.error(this.props.savedUserDataErrorMessage, 4);
              }
            );
          } else {
            this.setState(
              {
                savedUserDataIsFetching: false,
                showRegistrationModal: false
              },
              () => {
                message.success('New user add successfully', 4);
                this.props.getAllUsersData();
              }
            );
          }
        });
      }
    );
  };

  renderChangePasswordModal = () => {
    return (
      <ChangePasswordForm
        isVisible={this.state.showResetPasswordModal}
        loaderIsVisible={this.props.updatedUserPasswordDataIsFetching}
        userData={this.state.selectedUser}
        onCancel={this.handleCloseResetPasswordModal}
        onSave={this.handleSubmitResetPasswordForm}
      />
    );
  };

  handleCloseResetPasswordModal = () => {
    this.setState({
      showResetPasswordModal: false
    });
  };

  handleSubmitResetPasswordForm = (values) => {
    this.props
      .updateUserPassword({
        id: this.state.selectedUser.id,
        password: values.password
      })
      .then(() => {
        if (!_.isEmpty(this.props.updatedUserPasswordDataErrorMessage)) {
          message.error(this.props.updatedUserPasswordDataErrorMessage, 4);
        } else {
          this.setState(
            {
              showResetPasswordModal: false
            },
            () => {
              message.success('Password changed successfully', 4);
            }
          );
        }
      });
  };

  renderEditAuditorModal = () => {
    if (!this.state.selectedUser) {
      return null;
    }
    return (
      <EditUserForm
        isVisible={this.state.showEditUserModal}
        onCancel={this.handleCloseEditUserForm}
        onCreate={this.handleSaveEditUserForm}
        userData={this.state.selectedUser}
        permissions={USER_PERMISSIONS}
        permissionKey='description'
        loaderIsVisible={this.state.updatedUserDataIsFetching}
        onChangePassword={this.handleChangePasswordClick}
      />
    );
  };

  handleChangePasswordClick = () => {
    this.setState({
      showResetPasswordModal: true
    });
  };

  handleEditUser = (userData) => {
    this.setState({
      showEditUserModal: true,
      selectedUser: userData
    });
  };

  handleUserFilter = (userData) => {
    this.props.getUserQueuesData(userData.id).then(() => {
      this.setState({
        showUserFilterModal: true,
        selectedUser: userData,
        userFilters: this.props.userQueuesData
      });
    });
  };

  handleSaveEditUserForm = (formInstance) => {
    formInstance.validateFields((err, values) => {
      if (err) {
        return;
      }

      let permissionData = _.find(USER_PERMISSIONS, { id: values.role });
      values.role = permissionData.name;
      values = _.merge({}, values, {
        email: this.state.selectedUser.email
      });

      this.setState(
        {
          updatedUserDataIsFetching: true
        },
        () => {
          this.props.updateUserData(values).then(() => {
            if (!_.isEmpty(this.props.updatedUserDataErrorMessage)) {
              this.setState(
                {
                  updatedUserDataIsFetching: false
                },
                () => {
                  message.error(this.props.updatedUserDataErrorMessage, 4);
                }
              );
            } else {
              this.setState(
                {
                  updatedUserDataIsFetching: false,
                  showEditUserModal: false
                },
                () => {
                  message.success('User data changed successfully', 4);
                  this.props.getAllUsersData();
                }
              );
            }
          });
        }
      );
    });
  };

  handleCloseEditUserForm = () => {
    this.setState({
      showEditUserModal: false,
      selectedUser: null
    });
  };

  renderUserActions = (userData) => {
    return [
      this.renderEditButton(userData),
      // this.renderDeleteButton(userData),
      this.renderFilterButton(userData)
    ];
  };

  renderDeleteButton = (userData) => {
    return (
      <Tooltip
        placement='top'
        title='Delete user'
        key={`delete_user_${userData.id}`}
      >
        <Button
          icon='delete'
          onClick={() => this.handleDeleteAuditor(userData)}
        />
      </Tooltip>
    );
  };

  handleDeleteAuditor = (userData) => {
    this.setState(
      {
        isVisibleConfirm: true
      },
      () => {
        this.renderConfirmModal(userData);
      }
    );
  };

  renderConfirmModal = (userData) => {
    const { isVisibleConfirm } = this.state;

    return Modal.confirm({
      visible: isVisibleConfirm,
      title: 'Delete confirmation',
      content: `Are you sure, you want to delete "${userData.email}"`,
      keyboard: false,
      maskClosable: false,
      okText: 'Delete',
      cancelText: 'Cancel',
      onOk: () => this.handleAgree(userData.email),
      onCancel: () => this.handleCancelDelete()
    });
  };

  handleAgree = () => {
    // this.props.deleteTemplateById(templateId).then(() => {
    this.setState(
      {
        isVisibleConfirm: false
      },
      () => {
        Modal.destroyAll();
      }
    );
    // })
  };

  handleCancelDelete = () => {
    this.setState(
      {
        isVisibleConfirm: false
      },
      () => {
        Modal.destroyAll();
      }
    );
  };

  renderEditButton = (userData) => {
    return (
      <Tooltip
        placement='top'
        title='Edit user data'
        key={`edit_user_${userData.id}`}
      >
        <Button icon='edit' onClick={() => this.handleEditUser(userData)} />
      </Tooltip>
    );
  };

  renderFilterButton = (userData) => {
    return (
      <Tooltip
        placement='top'
        title='Filters'
        key={`user_filter_${userData.id}`}
      >
        <Button icon='filter' onClick={() => this.handleUserFilter(userData)} />
      </Tooltip>
    );
  };

  prepareUserTableData = () => {
    const { allUsersData } = this.props;
    const { searchTerm, showDisabledUsers } = this.state;

    // Filter users based on search term
    let filteredUsers = allUsersData;
    if (searchTerm) {
      filteredUsers = allUsersData.filter(userData => {
        const username = userData.name ? userData.name.toLowerCase() : '';
        const email = userData.email ? userData.email.toLowerCase() : '';
        const search = searchTerm.toLowerCase();
        return username.includes(search) || email.includes(search);
      });
    }

    // Filter out disabled users if showDisabledUsers is false
    if (!showDisabledUsers) {
      filteredUsers = filteredUsers.filter(userData => userData.active);
    } else {
      // Sort users so that active users come first, then disabled users
      filteredUsers = _.sortBy(filteredUsers, [(userData) => !userData.active]);
    }

    return _.map(filteredUsers, (userData) => {
      return _.merge({}, userData, {
        statusIcon: (
          <Tooltip
            placement='top'
            title={userData.active ? 'Active' : 'Disabled'}
            key={`user_status_${userData.id}`}
          >
            <Icon
              type='user'
              style={{
                color: userData.active ? '#00AF00' : '#E93C3C'
              }}
            />
          </Tooltip>
        ),
        editButton: this.renderUserActions(userData)
      });
    });
  };

  render() {
    return (
      <Row>
        {this.state.showEditUserModal && this.renderEditAuditorModal()}
        {this.state.showRegistrationModal && this.renderRegistrationModal()}
        {this.state.showUserFilterModal && this.renderUserFiltersModal()}
        {this.state.showResetPasswordModal && this.renderChangePasswordModal()}
        <Col span={24} style={{ marginBottom: 15 }}>
          <Row type="flex" justify="space-between" align="middle">
            <Col>
              <Button onClick={() => this.showRegistrationModal()}>
                <Icon
                  type='plus'
                  style={{ color: '#3BA4E6' }}
                // onClick={() => this.showRegistrationModal()}
                />
                <span>Create user</span>
              </Button>
            </Col>
            <Col>
              <Row type="flex" align="middle" gutter={16}>
                <Col>
                  <Checkbox
                    checked={this.state.showDisabledUsers}
                    onChange={this.handleShowDisabledUsersChange}
                  >
                    Show disabled users
                  </Checkbox>
                </Col>
                <Col>
                  <Input.Search
                    placeholder="Search by username or email..."
                    value={this.state.searchTerm}
                    onChange={this.handleSearchChange}
                    style={{ width: 300 }}
                    allowClear
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Table
            bordered
            rowKey='id'
            loading={this.props.allUsersDataIsFetching}
            columns={USER_TABLE_COLUMNS}
            dataSource={this.prepareUserTableData()}
          />
        </Col>
      </Row>
    );
  }
}

function mapStateToProps({ adminStore }) {
  return {
    allUsersData: adminStore.allUsersData,
    allUsersDataIsFetching: adminStore.allUsersDataIsFetching,
    userQueuesData: adminStore.userQueuesData,
    updatedUserData: adminStore.updatedUserData,
    updatedUserDataIsFetching: adminStore.updatedUserDataIsFetching,
    updatedUserDataErrorMessage: adminStore.updatedUserDataErrorMessage,
    savedUserData: adminStore.savedUserData,
    savedUserDataIsFetching: adminStore.savedUserDataIsFetching,
    savedUserDataErrorMessage: adminStore.savedUserDataErrorMessage,
    userQueueValidData: adminStore.userQueueValidData,
    userQueueValidDataIsFetching: adminStore.userQueueValidDataIsFetching,
    userQueueValidDataErrorMessage: adminStore.userQueueValidDataErrorMessage,
    userQueueCount: adminStore.userQueueCount,
    userQueueCountIsFetching: adminStore.userQueueCountIsFetching,
    userQueueCountErrorMessage: adminStore.userQueueCountErrorMessage,
    replacedUserQueuesData: adminStore.replacedUserQueuesData,
    replacedUserQueuesDataIsFetching:
      adminStore.replacedUserQueuesDataIsFetching,
    replacedUserQueuesDataErrorMessage:
      adminStore.replacedUserQueuesDataErrorMessage,
    updatedUserPasswordData: adminStore.updatedUserPasswordData,
    updatedUserPasswordDataIsFetching:
      adminStore.updatedUserPasswordDataIsFetching,
    updatedUserPasswordDataErrorMessage:
      adminStore.updatedUserPasswordDataErrorMessage,
    runQueryData: adminStore.runQueryData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAllUsersData: bindActionCreators(getAllUsersData, dispatch),
    getUserQueuesData: bindActionCreators(getUserQueuesData, dispatch),
    updateUserData: bindActionCreators(updateUserData, dispatch),
    createNewUser: bindActionCreators(createNewUser, dispatch),
    validateUserQueue: bindActionCreators(validateUserQueue, dispatch),
    getQueueCount: bindActionCreators(getQueueCount, dispatch),
    changeRunQueryObject: bindActionCreators(changeRunQueryObject, dispatch),
    updateUserQueues: bindActionCreators(updateUserQueues, dispatch),
    updateUserPassword: bindActionCreators(updateUserPassword, dispatch),
    clearQueueCount: bindActionCreators(clearQueueCount, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminPage);
